(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d2db-header"]) return;
  try {
    
function setupThemePickers() {
  document.querySelectorAll('[data-d2db-theme]').forEach(select => {
    select.value = document.documentElement.dataset.appearance === 'light' ? 'light' : 'dark';
    if (select.dataset.ready) return;
    select.dataset.ready = 'true';
    select.addEventListener('change', () => {
      const appearance = select.value === 'light' ? 'light' : 'dark';
      document.documentElement.dataset.appearance = appearance;
      try { localStorage.setItem('d2db-appearance-v2', appearance); } catch (error) {}
      document.querySelectorAll('[data-d2db-theme]').forEach(other => { other.value = appearance; });
    });
  });
}
setupThemePickers();
document.addEventListener('shopify:section:load', setupThemePickers);

function setupApplicationMenus() {
  document.querySelectorAll('.d2db-app-menu').forEach(menu => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    const trigger = menu.querySelector('summary');
    let hoverOpened = false;
    trigger.addEventListener('click', event => {
      if (event.detail > 0 && hoverOpened) event.preventDefault();
      hoverOpened = false;
    });
    menu.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches && !menu.open) { hoverOpened = true; menu.open = true; }
    });
    menu.addEventListener('pointerleave', event => {
      hoverOpened = false;
      if (event.pointerType === 'mouse' && !menu.contains(document.activeElement)) menu.open = false;
    });
    menu.addEventListener('focusout', () => {
      requestAnimationFrame(() => { if (!menu.contains(document.activeElement)) menu.open = false; });
    });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') { menu.open = false; trigger.focus(); event.preventDefault(); }
      if (event.key === 'ArrowDown' && event.target === trigger) { menu.open = true; menu.querySelector('a')?.focus(); event.preventDefault(); }
    });
  });
}
setupApplicationMenus();
document.addEventListener('shopify:section:load', setupApplicationMenus);
document.addEventListener('click', event => {
  document.querySelectorAll('.d2db-app-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d2db-page"]) return;
  try {
    
function setupChargeChart() {
  const select = document.getElementById('d2db-chart-voltage');
  const type = document.getElementById('d2db-chart-type');
  const image = document.getElementById('d2db-charge-chart');
  if (!select || !type || !image || select.dataset.ready) return;
  select.dataset.ready = 'true';
  const section = image.closest('section');
  const heading = section.querySelector('[data-voltage-table-heading]');
  const tbody = section.querySelector('tbody');
  const reference = {
    flooded: [[100,12.73],[90,12.62],[80,12.50],[70,12.37],[60,12.24],[50,12.10],[40,11.96],[30,11.81],[20,11.66],[10,11.51]],
    agm: [[100,12.84],[75,12.54],[50,12.24],[25,11.94],[0,11.64]],
    gel: [[100,12.84],[75,12.66],[50,12.36],[25,12.00],[0,11.82]]
  };
  function update() {
    const voltage = Number(select.value);
    const option = select.selectedOptions[0];
    const kind = type.value;
    const label = type.selectedOptions[0].textContent;
    image.src = kind === 'flooded' ? option.dataset.chartSrc : option.dataset[kind + 'Src'];
    image.alt = `${voltage}V ${label} deep-cycle battery at rest: state of charge versus voltage, with cycling guidance bands.`;
    if (heading) heading.textContent = `${label} resting voltage — ${voltage}V system`;
    tbody.replaceChildren(...reference[kind].map(([soc, volts]) => {
      const row = document.createElement('tr');
      const charge = document.createElement('td');
      const value = document.createElement('td');
      charge.textContent = `${soc}%`;
      value.textContent = `${(volts * voltage / 12).toFixed(2)} V`;
      row.append(charge, value);
      return row;
    }));
  }
  select.disabled = false;
  type.disabled = false;
  select.addEventListener('change', update);
  type.addEventListener('change', update);
  update();
}
setupChargeChart();
document.addEventListener('shopify:section:load', setupChargeChart);

function setupRecyclingFinder() {
  const select = document.getElementById('d2db-recycle-town');
  if (!select || select.dataset.ready) return;
  select.dataset.ready = 'true';
  const finder = select.closest('.d2db-recycle-finder');
  const groups = Array.from(finder.querySelectorAll('.d2db-recycle-town'));
  const status = document.getElementById('d2db-recycle-status');
  const initial = status.textContent;
  finder.dataset.ready = 'true';
  function update() {
    groups.forEach(group => {
      const chosen = group.dataset.town === select.value;
      group.hidden = !chosen;
      group.open = chosen;
    });
    status.textContent = select.value ? select.selectedOptions[0].textContent : initial.split(',')[0] + '.';
  }
  select.disabled = false;
  select.addEventListener('change', update);
  update();
}
setupRecyclingFinder();
document.addEventListener('shopify:section:load', setupRecyclingFinder);

function voltageDropAWGSizes() {
  return [18,16,14,12,10,8,6,4,3,2,1,0,-1,-2,-3].map(gauge => ({
    label: gauge > 0 ? gauge + ' AWG' : (1 - gauge) + '/0 AWG',
    area: Math.PI / 4 * Math.pow(0.127 * Math.pow(92,(36-gauge)/39),2)
  }));
}
function calculateVoltageDrop(voltage, load, unit, length, temperature, size) {
  const sizes = [1.5,2.5,4,6,10,16,25,35,50,70,95,120,150,185,240];
  if (![12,24,48].includes(voltage) || !['amps','kw'].includes(unit) || ![20,70,90].includes(temperature) || !Number.isFinite(load) || load <= 0 || !Number.isFinite(length) || length <= 0 || (size !== 'auto' && !sizes.includes(Number(size)) && !voltageDropAWGSizes().some(wire => String(wire.area) === String(size)))) return null;
  const amps = unit === 'kw' ? load * 1000 / voltage : load;
  const numerator = amps * 2 * length * 0.017241 * (1 + 0.00393 * (temperature - 20));
  if (!Number.isFinite(numerator) || !Number.isFinite(amps)) return null;
  const recommended = sizes.find(area => numerator / area / voltage < 0.02 - 1e-12);
  const awg = voltageDropAWGSizes().find(wire => numerator / wire.area / voltage < 0.02 - 1e-12);
  const area = size === 'auto' ? recommended : Number(size);
  const drop = area ? numerator / area : null;
  return {amps, awg, awgDrop: awg ? numerator / awg.area : null, recommended, recommendedDrop: recommended ? numerator / recommended : null, area, drop, percent: area ? drop / voltage * 100 : null};
}
function setupVoltageDrop() {
  const section = document.getElementById('voltage-drop-calculator');
  if (!section || section.dataset.ready) return;
  section.dataset.ready = 'true';
  const field = name => section.querySelector('#vd-' + name);
  const result = field('result');
  const fmt = value => value.toLocaleString('en-NZ',{maximumFractionDigits:3});
  function update() {
    field('load-label').textContent = field('unit').value === 'kw' ? 'Load (kW)' : 'Load (A)';
    const voltage = Number(field('voltage').value);
    const data = calculateVoltageDrop(voltage, Number(field('load').value), field('unit').value, Number(field('length').value), Number(field('temperature').value), 'auto');
    result.replaceChildren();
    if (!data) {result.textContent = 'Enter a positive load and one-way distance to calculate.'; return;}
    function card(title, value, note, className) {
      const card = document.createElement('div');
      card.className = className || '';
      const label = document.createElement('span'); label.textContent = title;
      const number = document.createElement('strong'); number.textContent = value;
      const detail = document.createElement('small'); detail.textContent = note;
      card.append(label,number,detail); result.append(card);
    }
    card('Minimum metric size — below 2%', data.recommended ? data.recommended + ' mm²' : 'Over 240 mm²', data.recommended ? `${fmt(data.amps)} A · ${fmt(data.recommendedDrop)} V drop (${fmt(data.recommendedDrop / voltage * 100)}%). Check current rating before choosing.` : 'No size in this list meets the target. Shorten the run or seek cable-sizing advice.', 'vd-recommendation');
    card('Minimum AWG size — below 2%', data.awg ? data.awg.label : 'Over 4/0 AWG', data.awg ? `≈ ${fmt(data.awg.area)} mm² · ${fmt(data.awgDrop)} V drop (${fmt(data.awgDrop / voltage * 100)}%). Check current rating before choosing.` : 'No AWG size in this list meets the target. See the metric result or seek cable-sizing advice.', 'vd-recommendation');
  }
  section.querySelectorAll('input,select').forEach(input => input.addEventListener('input',update));
  update();
}
setupVoltageDrop();
document.addEventListener('shopify:section:load',setupVoltageDrop);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d2db-product"]) return;
  try {
    
if (!customElements.get('d2db-gallery')) {
  customElements.define('d2db-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const layout = this.closest('.d2db-product-layout');
      const apps = layout?.querySelector('[data-product-apps]');
      if (apps) {
        layout.querySelectorAll('.d2db-specifications .d2db-bluetooth-specs').forEach(panel => apps.append(panel));
      }
      this.slides = [...this.querySelectorAll('.d2db-gallery-slide')];
      this.thumbnails = [...this.querySelectorAll('[data-gallery-index]')];
      if (!this.slides.length) return;
      this.dialog = this.querySelector('.d2db-image-dialog');
      this.dialog.addEventListener('close', () => this.restorePage());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.zoom = 1;
      this.zoomViewport = this.querySelector('[data-gallery-full-image]');
      this.zoomViewport.addEventListener('dblclick', event => {
        event.preventDefault();
        this.setZoom(this.zoom > 1 ? 1 : 2);
      });
      this.zoomViewport.addEventListener('pointerdown', event => {
        if (this.zoom <= 1 || event.pointerType !== 'mouse' || event.button !== 0) return;
        event.preventDefault();
        this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: this.zoomViewport.scrollLeft, top: this.zoomViewport.scrollTop};
        this.zoomViewport.setPointerCapture(event.pointerId);
        this.zoomViewport.classList.add('is-dragging');
      });
      this.zoomViewport.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.zoomViewport.scrollLeft = this.drag.left - (event.clientX - this.drag.x);
        this.zoomViewport.scrollTop = this.drag.top - (event.clientY - this.drag.y);
      });
      const endDrag = () => {
        this.drag = null;
        this.zoomViewport.classList.remove('is-dragging');
      };
      this.zoomViewport.addEventListener('pointerup', endDrag);
      this.zoomViewport.addEventListener('pointercancel', endDrag);
      this.zoomViewport.addEventListener('lostpointercapture', endDrag);
      this.zoomObserver = new ResizeObserver(() => {
        if (this.dialog.open) this.setZoom(this.zoom);
      });
      this.zoomObserver.observe(this.zoomViewport);
      this.index = 0;
      this.classList.add('is-ready');
      this.querySelectorAll('[hidden]').forEach(element => element.hidden = false);
      this.show(0);
      this.addEventListener('click', event => {
        const slide = event.target.closest('.d2db-gallery-slide');
        if (slide) {
          event.preventDefault();
          this.openImage(slide);
          return;
        }
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-zoom-in')) this.setZoom(this.zoom + .5);
        if (button.hasAttribute('data-zoom-out')) this.setZoom(this.zoom - .5);
        if (button.hasAttribute('data-zoom-reset')) this.setZoom(1);
        if (button.hasAttribute('data-gallery-close')) this.dialog.close();
        if (button.hasAttribute('data-gallery-index')) this.show(Number(button.dataset.galleryIndex));
        if (button.hasAttribute('data-gallery-step')) this.show(this.index + Number(button.dataset.galleryStep));
      });
      this.addEventListener('keydown', event => {
        if (this.dialog.open && ['+', '=', '-', '0'].includes(event.key)) {
          event.preventDefault();
          this.setZoom(event.key === '0' ? 1 : this.zoom + (event.key === '-' ? -.5 : .5));
          return;
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || (this.dialog.open && this.zoom > 1) || event.target.closest('.d2db-image-zoom')) {
          this.touchStart = null;
          return;
        }
        this.touchStart = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
      }, {passive: true});
      this.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart[0];
        const dy = event.changedTouches[0].clientY - this.touchStart[1];
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
        this.touchStart = null;
      }, {passive: true});
    }
    openImage(slide) {
      this.show(this.slides.indexOf(slide));
      this.renderFullImage();
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.setZoom(1);
    }
    renderFullImage() {
      const slide = this.slides[this.index];
      this.imageTrigger = slide;
      const image = slide.querySelector('img').cloneNode();
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.loading = 'eager';
      image.src = slide.href;
      image.draggable = false;
      const canvas = document.createElement('div');
      canvas.className = 'd2db-image-zoom-canvas';
      canvas.append(image);
      this.zoomViewport.replaceChildren(canvas);
      this.zoom = 1;
      this.drag = null;
      this.zoomViewport.classList.remove('is-dragging');
      image.addEventListener('load', () => {
        if (this.zoomViewport.contains(image)) this.setZoom(this.zoom);
      }, {once: true});
      this.setZoom(1);
      this.querySelector('[data-dialog-position]').textContent = `${this.index + 1} / ${this.slides.length}: ${image.alt}`;
    }
    setZoom(value) {
      const viewport = this.zoomViewport;
      const image = viewport.querySelector('img');
      const canvas = viewport.firstElementChild;
      const oldZoom = this.zoom || 1;
      const width = viewport.clientWidth;
      const height = viewport.clientHeight;
      const centerX = (viewport.scrollLeft + width / 2) / Math.max(1, viewport.scrollWidth);
      const centerY = (viewport.scrollTop + height / 2) / Math.max(1, viewport.scrollHeight);
      this.zoom = Math.max(1, Math.min(4, value));
      viewport.classList.toggle('is-zoomed', this.zoom > 1);
      this.querySelector('[data-zoom-level]').textContent = `${Math.round(this.zoom * 100)}%`;
      this.querySelector('[data-zoom-out]').disabled = this.zoom === 1;
      this.querySelector('[data-zoom-in]').disabled = this.zoom === 4;
      if (!image || !width || !height) return;
      const naturalWidth = image.naturalWidth || Number(image.getAttribute('width')) || width;
      const naturalHeight = image.naturalHeight || Number(image.getAttribute('height')) || height;
      const fit = Math.min(width / naturalWidth, height / naturalHeight);
      image.style.width = `${naturalWidth * fit * this.zoom}px`;
      image.style.height = `${naturalHeight * fit * this.zoom}px`;
      canvas.style.width = `${Math.max(width, naturalWidth * fit * this.zoom)}px`;
      canvas.style.height = `${Math.max(height, naturalHeight * fit * this.zoom)}px`;
      viewport.scrollLeft = this.zoom === 1 ? 0 : (oldZoom === 1 ? .5 : centerX) * viewport.scrollWidth - width / 2;
      viewport.scrollTop = this.zoom === 1 ? 0 : (oldZoom === 1 ? .5 : centerY) * viewport.scrollHeight - height / 2;
    }
    restorePage() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (this.imageTrigger?.isConnected) this.imageTrigger.focus({preventScroll: true});
    }
    disconnectedCallback() {
      this.zoomObserver?.disconnect();
      if (this.dialog?.open) this.dialog.close();
      this.restorePage();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-current', i === this.index));
      this.thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      const position = this.querySelector('[data-gallery-position]');
      if (position) position.textContent = this.index + 1;
      if (this.dialog.open) this.renderFullImage();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
